export const downloadWordFile = (base64Data, fileName) => {
  const linkSource = `data:application/msword;base64,${base64Data.split(',')[1]}`;
  const downloadLink = document.createElement('a');
  const fileNameWithExtension = `${fileName}.doc`;
  downloadLink.href = linkSource;
  downloadLink.download = fileNameWithExtension;
  downloadLink.click();
};
